// Import things.
import styles from './sass/main.scss';
import { Gallery } from './components/Gallery';

// window exports.
window.MoxiGallery = Gallery;



// WEBPACK FOOTER //
// ./src/main.js